"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_PaymentReconciliation = exports.PaymentReconciliationOutcomeKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_Period_1 = require("./RTTI_Period");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_date_1 = require("../Scalar/RTTI_date");
var RTTI_Money_1 = require("./RTTI_Money");
var RTTI_PaymentReconciliation_Detail_1 = require("./RTTI_PaymentReconciliation_Detail");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_PaymentReconciliation_ProcessNote_1 = require("./RTTI_PaymentReconciliation_ProcessNote");
var PaymentReconciliationOutcomeKind;
(function (PaymentReconciliationOutcomeKind) {
    PaymentReconciliationOutcomeKind["_queued"] = "queued";
    PaymentReconciliationOutcomeKind["_complete"] = "complete";
    PaymentReconciliationOutcomeKind["_error"] = "error";
    PaymentReconciliationOutcomeKind["_partial"] = "partial";
})(PaymentReconciliationOutcomeKind = exports.PaymentReconciliationOutcomeKind || (exports.PaymentReconciliationOutcomeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_PaymentReconciliation = t.recursion('IPaymentReconciliation', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('PaymentReconciliation'),
            paymentAmount: RTTI_Money_1.RTTI_Money
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            identifier: t.array(RTTI_Identifier_1.RTTI_Identifier),
            status: RTTI_code_1.RTTI_code,
            _status: RTTI_Element_1.RTTI_Element,
            period: RTTI_Period_1.RTTI_Period,
            created: RTTI_dateTime_1.RTTI_dateTime,
            _created: RTTI_Element_1.RTTI_Element,
            paymentIssuer: RTTI_Reference_1.RTTI_Reference,
            request: RTTI_Reference_1.RTTI_Reference,
            requestor: RTTI_Reference_1.RTTI_Reference,
            outcome: (0, EnumType_1.createEnumType)(PaymentReconciliationOutcomeKind, 'PaymentReconciliationOutcomeKind'),
            _outcome: RTTI_Element_1.RTTI_Element,
            disposition: t.string,
            _disposition: RTTI_Element_1.RTTI_Element,
            paymentDate: RTTI_date_1.RTTI_date,
            _paymentDate: RTTI_Element_1.RTTI_Element,
            paymentIdentifier: RTTI_Identifier_1.RTTI_Identifier,
            detail: t.array(RTTI_PaymentReconciliation_Detail_1.RTTI_PaymentReconciliation_Detail),
            formCode: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            processNote: t.array(RTTI_PaymentReconciliation_ProcessNote_1.RTTI_PaymentReconciliation_ProcessNote)
        })
    ]);
});
//# sourceMappingURL=RTTI_PaymentReconciliation.js.map